import { useEffect, useMemo } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';

import useAuthentication from '../../hooks/useAuthentication';
import useGncHistory from '../../hooks/useGncHistory';
import useUserManagement from '../../hooks/useUserManagement';

import { ProjectContentsProvider } from '../../contexts/ProjectContentsContext';
import { QualityContentsProvider } from '../../contexts/QualityContentsContext';

const ProtectedLayout = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const { userHasRole } = useUserManagement();

    const {
        currentUser,
        isAuthenticated,
        shouldConfigure2FA,
        shouldChangePassword,
        shouldAgreeToTOC,
        logout,
    } = useAuthentication();

    const isAuthorised = useMemo(() => isAuthenticated && userHasRole(currentUser, 'normal_user'), [isAuthenticated, currentUser]);

    const { addToHistory } = useGncHistory()

    useEffect(() => {
        if (!isAuthenticated) {
            return navigate('/login', { replace: true })
        }

        if (!isAuthorised) {
            return logout()
        }

        if (shouldChangePassword) {
            return navigate("/account/update_password")
        }

        if(shouldConfigure2FA) {
            return navigate("/account/2fa")
        }

        if(shouldAgreeToTOC) {
            return navigate("/company_signup")
        }

        addToHistory(location.pathname)
    }, [location.pathname, isAuthenticated, shouldConfigure2FA, shouldChangePassword, shouldAgreeToTOC])

    
    if (!isAuthenticated || !isAuthorised) {
        return null
    }

    return (
        <QualityContentsProvider>
            <ProjectContentsProvider>
                <Outlet />
            </ProjectContentsProvider>
        </QualityContentsProvider>
    )
};

export default ProtectedLayout
